import React from 'react';
import './footer.css'; // Import the CSS file for styling

const Footer = () => {
  return (
    <footer className="footer">
        <div className="main-content">
      <div className="footer-certification">
        <h3>ISO 9001:2015 Certified Company  </h3>
        <div className="certification-logos">

        <a href="#home"><img src="./images/fav_icon.png" alt="Pyramid Industries Logo" /></a>
         
        </div>
      </div>
      <div className="footer-services">
        <h3>SERVICES</h3>
        <ul>
            <li>Electric Insulation Coating.</li>
            <li>High Reflective Coating and Paint.</li>
            <li>Anticorrosing Protective Coatings.</li>
            <li>Highe End Industrial Flooring</li>
            <li>Antiskid Car Parking FLooring</li>
            <li>Floorcoat</li>
            <li>Waterproofing Systems</li>
        </ul>
      </div>
      <div className="footer-contact">
        <h3>CONTACT US</h3>
        <div className="contact-details">
          <div>
            <h4>Office address:</h4>
            <p>516/C2/202, AkashHsg Society, Near Bhandar Gruha, Kombadpada, Kasar Ali, Bhiwandi- 421302 </p>
          </div>
          {/* <div>
            <h4>Registered office:</h4>
            <p>203, Padmavishwa Oxyrich -2, Rameshwar Nagar, Ganagapur Road, Nashik -422013</p>
          </div> */}
          <div>
            <p>Milind Kirange, CEO: +91 7021264210</p>
            <p>Email: salespyramidindustries@gmail.com</p>
          </div>
          <div className="social-media">
            <a href="https://www.facebook.com"><i className="fab fa-facebook-f"></i></a>
            <a href="https://www.youtube.com"><i className="fab fa-youtube"></i></a>
            <a href="https://www.linkedin.com"><i className="fab fa-linkedin-in"></i></a>
          </div>
        </div>
      </div>
      </div>
      <div className="footer-bottom">
        <p>© 2024 Pyramids Industries All rights reserved</p>
        
      </div>

        
    </footer>

    
  );
};

export default Footer;
